import { ARRAY, indexArray, isRunningStatus } from '../../common/utils/Utils'
import { CUSTOM_ACTIVATION_TITLE } from '../constants/LabelConstants'

export const calculateNewTsg = (currentTsgName, tsgName, tsgDropDownDetails, count = 0) => {
  const isNewTsgName = tsgDropDownDetails.some((each) => {
    return each.description === tsgName
  })
  if (!isNewTsgName) {
    return tsgName
  }
  else {
    count++
    return calculateNewTsg(currentTsgName, `${currentTsgName} - ${count}`, tsgDropDownDetails, count)
  }
}

export const getDateFormat = ((row, dateValue) => {
  const license_expiration = dateValue ?? (ARRAY.hasArray(row?.original?.entitlements) ? row?.original?.entitlements[0]?.license_expiration : '')
  if (license_expiration) {
    const [year, month, day] = license_expiration.split('-')
    return `${month}/${day.slice(0, 2)}/${year}`
  }
})

/**
 * To validate the associations and co-existance of instances in TSG
 * @param primaryAppInfo
 * @param tsgInstances
 */
export const getMissingDependencies = (primaryAppInfo, tsgInstances) => {
  const requiredAssociations = primaryAppInfo?.associations?.flatMap((each => (each?.required ? [each.app_id] : [])))
  const tsgInstanceList = indexArray(tsgInstances, 'app_id')
  const isInstanceRunning = (instance) => (instance && isRunningStatus(instance))
  const missingAssociations = requiredAssociations?.flatMap(appId => (!isInstanceRunning(tsgInstanceList.get(appId)) ? [appId] : []))
  const appsNotAllowed = primaryAppInfo?.setup?.extra?.apps_not_allowed
  const notAllowedInstances = appsNotAllowed?.flatMap(each => (tsgInstanceList.has(each) ? [each] : []))
  return { missingAssociations, notAllowedInstances }
}

/**
 * Get the application title.
 * @param license
 * @param appDef
 */
export const getAppTitle = (license, appDef) => {
  return CUSTOM_ACTIVATION_TITLE[appDef?.app_id] || license?.license_display_name || appDef?.display_name
}
